module.exports = __webpack_public_path__ + "img/logo.e90e1491.png";